import { useTranslation } from 'react-i18next';

import { GuidedModal, GuidedModalOption } from 'src/features/guided-modal';

interface PersonalizedGuidanceModalProps {
  isOpen: boolean;
  /** Any way out, including "Skip for now". */
  onClose: () => void;
  onBookCall: () => void;
}

/** The checklist 2 "Get personalized guidance" step: an optional onboarding call. */
export const PersonalizedGuidanceModal = ({
  isOpen,
  onClose,
  onBookCall,
}: PersonalizedGuidanceModalProps) => {
  const { t } = useTranslation();

  return (
    <GuidedModal
      isOpen={isOpen}
      title={t(
        ($) =>
          $.page_apps.app_builder.getting_started.personalized_guidance.title,
      )}
      description={t(
        ($) =>
          $.page_apps.app_builder.getting_started.personalized_guidance
            .description,
      )}
      closeLabel={t(
        ($) => $.page_apps.app_builder.getting_started.guided.close,
      )}
      onClose={onClose}
      dismissLabel={t(
        ($) =>
          $.page_apps.app_builder.getting_started.personalized_guidance
            .skip_for_now,
      )}
      onDismiss={onClose}
    >
      <GuidedModalOption
        icon="Calendar"
        label={t(
          ($) =>
            $.page_apps.app_builder.getting_started.personalized_guidance
              .book_call,
        )}
        onClick={onBookCall}
      />
    </GuidedModal>
  );
};
